<template>
  <div class="navbar">
    <div style="z-index: 105;position: absolute; left: 20px;">
      <img src="hero/drinkaware.svg" width="100">
    </div>
    <img class="navbar__img" :src="dataModel[brandExperience].navLogoSrc">
  </div>
</template>

<script setup>

import dataModel from '../js/model.js';
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1"
  },
});
$(document).ready(function() {
  $('.navbar').css({
    backgroundColor: dataModel[props.brandExperience].navBgColor
  });
  
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  position: relative;
  width: 100%;
}
.navbar__img {
  display: block;
  padding: 15px 0px;
  width: 100px;
}
</style>